import { useContext, useState } from 'react';
import FormField from '../../components/FormField/FormField';
import StepHeader from '../../components/Wizard/StepHeader';
import { passwordMask } from '../../utils/Masks';
import Button from '../../components/Button/Button';
import ButtonLabel from '../../components/Button/ButtonLabel';

import Alert from '../../components/Alert';
import { SignUpContext } from '../../data/SignUp/SignUpContext';
import PasswordRuleValidator from '../../components/PasswordRuleValidator';
import RedirectSignIn from './RedirectSignIn';

export interface SignUpPasswordProps {
  allowSkipStep?: boolean;
  updateData?: boolean;
  previousPath?: number | null;
  nextPath?: number | null;
  handleChangeStep(e: number): void;
  context: any;
}

export default function SignUpPassword({
  nextPath,
  previousPath,
  handleChangeStep,
  context
}: SignUpPasswordProps) {
  const [errorRequest, setErrorRequest] = useState('');

  const { register, trigger, errors, touchedFields, getValues } =
    useContext(SignUpContext);

  function controlBackPage() {
    if (previousPath == 0 || previousPath) handleChangeStep(previousPath);
  }

  window.onpopstate = () => {
    controlBackPage();
  };

  async function checkValidateFields() {
    const validateFullName = await trigger(['password']);

    return new Promise((resolve) => {
      const fixedFieldsValidated = validateFullName;
      resolve(fixedFieldsValidated);
    });
  }

  async function nextStep() {
    checkValidateFields().then(async (response) => {
      if (response && nextPath) {
        handleChangeStep(nextPath);
      }
    });
  }

  return (
    <div className="card__section">
      <div className="card__top">
        <StepHeader
          title="Vamos criar uma senha"
          description={`Crie uma senha forte para sua Conta SBT utilizando o ${getValues('email')}.`}
        />

        <div className="form-group">
          <Alert
            message={errorRequest}
            errors={errors}
            onClose={setErrorRequest}
          />

          <FormField
            name="password"
            label="qual será sua senha?"
            type="password"
            placeholder="uma forte, mas fácil de lembrar"
            register={register('password')}
            onInput={passwordMask}
            error={errors}
            touchedFields={touchedFields}
            sufix
            isPassword
            prefix
            iconPrefix="password"
          />
        </div>

        <PasswordRuleValidator password={getValues('password')} />
      </div>

      <div className="button-group">
        <Button
          id="signup-name"
          full
          onClick={nextStep}
          disabled={
            !!errors?.password || !getValues('password')
            // (fieldHasSocialName && checkSocialName(fieldSocialName)) ||
            // !!errors?.birthDate ||
            // !touchedFields?.birthDate
          }
        >
          <ButtonLabel>continuar</ButtonLabel>
        </Button>

        <Button
          customColors="btn-ghost"
          aria-label="Voltar"
          onClick={controlBackPage}
        >
          <ButtonLabel>Voltar</ButtonLabel>
        </Button>

        <RedirectSignIn context={context} />
      </div>
    </div>
  );
}
